import { LayoutSpacer } from '@pendwa/common-browser/components/LayoutSpacer/index.js';
import clsx from 'clsx';
import React from 'react';
import { FragmentPageEntryPersonFragment } from '../../../../../../generated/graphql.js';
import { HeroPersonImage } from './components/Image.js';

export const HeroPerson: React.FC<{
  item: FragmentPageEntryPersonFragment;
}> = (props) => {
  return (
    <div className={clsx('grid grid-cols-12 gap-4')}>
      <div className={'relative col-span-12 md:col-span-4 lg:col-span-3'}>
        <HeroPersonImage item={props.item} />
      </div>

      <div className={'col-span-12 md:col-span-8 lg:col-span-9'}>
        <LayoutSpacer>
          <h1 className="text-4xl font-extrabold text-indigo-600">{props.item.name}</h1>

          {(props.item.biography || props.item.summary) && (
            <p className="text-base text-indigo-600">{props.item.biography || props.item.summary}</p>
          )}
        </LayoutSpacer>
      </div>
    </div>
  );
};
